import {Image, Text, Center, VStack, Box, Button, Input, useToast, Heading, HStack, Tooltip} from "@chakra-ui/react";
import {useLocation, useNavigate} from "react-router-dom"
import React from 'react';
import LogoClinica from '../img/logo_integrada.png'
import CardUsuario from '../components/UserCard'
import {useState} from "react";
import {useEffect} from "react";
import {ApiGestorMed} from "../api/ApiGMed";
import {ClienteF} from "../util/ClienteFormarte";
import Calendario from "../components/Calendario";
import "../sass/agendamento.scss"
import ModalConfirm from "../modal/ModalConfirmacao";
import {Transform} from "number-validation";
import HorariosListButtons from "../components/HorariosListButtons";
import SelectComposto from "../components/SelectComposto";
import {ArrowBack} from "@material-ui/icons";


function FormAgenda(props) {
    const
        [loadingU, setLoadingU] = useState(false),
        [part, setPart] = useState(false),
        [unidades, setUnidades] = useState([]),
        [currentUnidade, setCurrentUnidade] = useState(),
        [loadingE, setLoadingE] = useState(false),
        [especialidades, setEspecialidades] = useState([]),
        [loadingM, setLoadingM] = useState(false),
        [medicos, setMedicos] = useState([]),
        [currentDoctor, setCurrentDoctor] = useState({}),
        [loadingP, setLoadingP] = useState(false),
        [procedimentos, setProcedimentos] = useState([]),
        [showForm, setShowForm] = useState(false),
        [diasCompletos, setDiasCompletos] = useState([]),
        [isOpen, setIsOpen] = useState(false),
        [dias, setDias] = useState([]),
        [selectedDate, setSelectedDate] = useState(),
        [horarios, setHorarios] = useState([]),
        [valueHours, setValueHours] = useState([]),
        [dataConvertida, setDataConvertida] = useState(''),
        [tel, setTel] = useState(''),
        transform = new Transform(),
        navigate = useNavigate(),
        [showModal, setShowModal] = useState(false),
        [formContol, setFromControl] = useState({
            nomePaciente: '',
            unidade: '',
            telefone: '',
            idConvenio: 0,
            idMedico: 0,
            data: '',
            codPaciente: '',
            procedimento: '',
            obs: '',
            horario: '',
            nomeMedico: '',
            idProcedimento: ''
        }),
        toast = useToast(),
        [canSubmit, setCanSubmit] = useState(false);

    useEffect(
        () => {
            getUnidades()
        },
        [],
    );

    const getUnidades = async () => {
        const data = await ApiGestorMed.getUnidades();
        if (typeof (data) === 'string') {
            toast({
                title: `Erro ao carregar unidades!`,
                status: "error",
                isClosable: true
            });
            setTimeout(() => {
                navigate("/")
            }, "2000")
        } else {
            setUnidades(data)
            setLoadingU(true)
        }
    }

    const changeSelect = async (e) => {
        let id = e.target.value;
        resetaState()
        setCurrentUnidade(id)
        getEspecialidadesUnidade(id)
    }

    const getEspecialidadesUnidade = async (id) => {
        const dataE = await ApiGestorMed.getEspecialidades(id);
        if (typeof (data) === 'string') {
            toast({
                title: `Erro ao carregar especialidades!`,
                status: "error",
                isClosable: true
            });
            setTimeout(() => {
                navigate("/")
            }, "2000")
        } else {
            setEspecialidades(dataE)
            setLoadingE(true)
        }
    }
    const changeSelectEsp = async (e) => {
        let id = e.target.value;
        setShowForm(false)
        setIsOpen(false)
        setLoadingM(false)
        setLoadingP(false)
        if (id !== 'select') {
            getMedicos(id)
        }
    }

    const getMedicos = async (id) => {
        setFromControl({
            ...formContol,
            nomePaciente: props.usuario.nome,
            idConvenio: props.usuario.idCategoria,
            codPaciente: props.usuario.cpf
        })
        let dataE = [];
        dataE = await ApiGestorMed.getMedicos(id, currentUnidade);
        if (dataE !== "NO DATA") {
            setLoadingM(true)
            setMedicos(dataE)
        } else if (dataE.length === 0) {
            toast({
                title: `Não há medicos para essa especialidade!`,
                status: "error",
                isClosable: true
            });
            setMedicos(null)
        }
    }


    const changeSelectMedico = async (e) => {
        let id = e.target.value;
        setShowForm(false)
        setIsOpen(false)
        setLoadingP(false)
        setProcedimentos(null);
        setDias(null);
        if (id !== 'select') {
            getProcedimentos(id)
            getDiasDisponives(id)
        }
    }

    const getProcedimentos = async (idMedico) => {
        const data = await ApiGestorMed.getProcedimento(idMedico);
        if (typeof (data) === 'string') {
            toast({
                title: `Erro ao carregar procedimentos!`,
                status: "error",
                isClosable: true
            })
        } else {
            const filterProcedimentos = data.filter((e) => e.ativo == true);
            setProcedimentos(filterProcedimentos)
            setLoadingP(true)
        }
    }

    const changeProcedimento = async (e) => {
        const id = e.target.value;
        const procedimentoAtual = procedimentos.find(e => e.id == id)
        setFromControl({...formContol, procedimento: procedimentoAtual.nome, idProcedimento: procedimentoAtual.id})
        if (dias) {
            setPart(true)
            setIsOpen(true)
        }
    }


    const getDiasDisponives = async (idmedico) => {
        const date = new Date(),
            currentYear = date.getFullYear(),
            currentMonth = date.getMonth() + 1,
            mounths = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
        let data = [];
        if (idmedico !== '') {
            const medicoAtual = medicos.find(e => e.id == idmedico);
            setCurrentDoctor(medicoAtual)
            setFromControl({
                ...formContol,
                idMedico: parseInt(idmedico, 10),
                nomeMedico: medicoAtual.nome,
                unidade: currentUnidade,
                obs: medicoAtual.mensagem
            })
            data = await ApiGestorMed.getDias(currentUnidade, idmedico, currentMonth, currentYear);
            if (allAttributesZero(data)) {
                for (let i = currentMonth; i <= mounths[mounths.length - 1]; i++) {
                    data = await ApiGestorMed.getDias(currentUnidade, idmedico, i, currentYear);
                    if (!allAttributesZero(data)) {
                        break
                    }
                }
            }
            setDiasCompletos(data);
            if (data.length !== 0) {
                setDias(changeDias(data));
            } else {
                toast({
                    title: `Erro ao carregar dias disponíveis, tente novamente!`,
                    status: "error",
                    isClosable: true
                });
                setCurrentDoctor(null)
                setDias([])
            }
        }
    }

    async function fetchAvailableDays(unidade, idMedico, month, year) {
        try {
            const tempDates = await ApiGestorMed.getDias(unidade, idMedico, month, year);
            return tempDates;
        } catch (error) {
            return [];
        }
    }

    async function handleMonthChange(tempDates, unidade, idMedico, currentMonth, currentYear, mounths) {
        if (!mounths || mounths.length === 0) {
            return [];
        }

        for (let i = currentMonth; i <= mounths[mounths.length - 1]; i++) {
            tempDates = await fetchAvailableDays(unidade, idMedico, i, currentYear);
            if (!allAttributesZero(tempDates)) {
                return tempDates;
            }
        }
        return [];
    }

    function errorDataBasic(toast, text, setShowForm, setHorarios, setFromControl, canSubmit, setTel, setCanSubmit) {
        setShowForm(false);
        if (canSubmit) {
            setTel('');
            setCanSubmit(false);
        }
        toast({
            title: text,
            status: "error",
            isClosable: true
        });
        setHorarios([]);
        setFromControl(prevState => ({...prevState, horario: ''}));
    }

    async function onMonthChange(date) {
        const currentYear = date.getFullYear();
        const currentMonth = date.getMonth() + 1;

        let tempDates = await fetchAvailableDays(currentUnidade, formContol.idMedico, currentMonth, currentYear);

        if (allAttributesZero(tempDates)) {
            tempDates = await handleMonthChange(currentUnidade, formContol.idMedico, currentMonth, currentYear, [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]);
            if (tempDates.length === 0) {
                toast({
                    title: `Não temos vagas neste mês, por favor verifique o próximo!`,
                    status: "warning",
                    isClosable: true
                });
                return;
            }
        }

        setDiasCompletos(tempDates);
        setDias(changeDias(tempDates));
    }

    async function onChangeCalendar(e) {
        setSelectedDate(e);
        const dataConv = e.toLocaleDateString();
        const currentYear = e.getFullYear();
        const currentMonth = e.getMonth() + 1;
        let currentDate = diasCompletos.find(dia => dia.datageral === dataConv);
        setDataConvertida(dataConv);
        setShowForm(true);

        if (!currentDate) {
            setHorarios([]);
            setShowForm(false);
            toast({
                title: `Selecione outra data/mês!`,
                status: "warning",
                isClosable: true
            });

            let tempDates = await fetchAvailableDays(currentUnidade, formContol.idMedico, currentMonth, currentYear);

            if (allAttributesZero(tempDates)) {
                tempDates = await handleMonthChange(currentUnidade, formContol.idMedico, currentMonth, currentYear, [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]);

                if (tempDates.length === 0) {
                    toast({
                        title: `Não temos vagas neste mês, por favor verifique o próximo!`,
                        status: "warning",
                        isClosable: true
                    });
                    return;
                }
            }

            setDiasCompletos(tempDates);
            if (tempDates.length !== 0) {
                currentDate = tempDates.find(dia => dia.datageral === dataConv);
                setDias(changeDias(tempDates));
            } else {
                toast({
                    title: `Erro ao carregar horários disponíveis, selecione outra data!`,
                    status: "error",
                    isClosable: true
                });
                return;
            }
        }

        if (currentDate.feriado === "S") {
            errorDataBasic(toast, 'A data que você escolheu é feriado, tente outra!', setShowForm, setHorarios, setFromControl, setCanSubmit, setTel, setCanSubmit);
        } else if (currentDate.disponivel <= 0) {
            errorDataBasic(toast, 'Não temos mais vagas disponíveis nessa data!', setShowForm, setHorarios, setFromControl, setCanSubmit, setTel, setCanSubmit);
        } else if (currentDate.tipohorario === 0 && currentDate.disponivel > 0) {
            getHorario(dataConv);
        } else {
            setHorarios([]);
            setFromControl(prevState => ({...prevState, horario: ''}));
        }
    }

    function allAttributesZero(arrayOfObjects) {
        return arrayOfObjects.every(obj => obj.disponivel === 0);
    }

    function changeDias(data) {
        let diasNoDisponiveis = [];
        let disponiveis = data.filter((e) => e.disponivel > 0 && e.feriado !== 'S')
        disponiveis.forEach(e => {
            diasNoDisponiveis.push(ClienteF.converterDateToPadrao(e.datageral).getDay());
        });
        return diasNoDisponiveis;
    }

    function disableWeekends(date) {
        return !dias.includes(date.getDay());
    }

    async function getHorario(e) {
        setHorarios([]);
        setCurrentDoctor(null)
        setFromControl({...formContol, data: e})
        setTel('')
        const objToGetHours = {
            idmedico: formContol.idMedico,
            date: e,
            idunidade: currentUnidade
        }
        const data = await ApiGestorMed.getHorarios(objToGetHours);
        if (data.length !== 0) {
            setHorarios(data);
        } else {
            setHorarios([]);
        }
    }

    function inputNumberCell(e) {
        let a = transform.onlyValid(e.target.value)
        setTel(a)
    }

    function changeRadio(e) {
        setFromControl({...formContol, horario: e, obs: ''})
        setValueHours(e);
    }

    function handleConfirm() {
        setShowModal(true)
    }

    function resetaState() {
        setEspecialidades(null);
        setMedicos(null);
        setLoadingE(false)
        setLoadingM(false)
        setLoadingP(false)
        setIsOpen(false)
        setShowForm(false)
    }

    function handleBack() {
        resetaState()
        setPart(!part)
    }

    useEffect(
        () => {
            if (tel.length === 11) {
                setCanSubmit(true)
                setFromControl({...formContol, telefone: tel, data: dataConvertida})

            } else {
                setFromControl({...formContol, telefone: ''})
                setCanSubmit(false)
            }
        },
        [tel, dataConvertida],
    );

    return (
        <div className="form-agenda">
            {!part && (
                <>
                    {loadingU && (
                        <SelectComposto tipo={'a unidade'} change={changeSelect} disable={props.disableForm} ordem={'1'}
                                        array={unidades}/>
                    )
                    }
                    {loadingE && (
                        <SelectComposto tipo={'a especilidade'} change={changeSelectEsp} disable={props.disableForm}
                                        ordem={'2'}
                                        array={especialidades}/>
                    )
                    }
                    {loadingM && (
                        <SelectComposto tipo={'o profissional'} change={changeSelectMedico} disable={props.disableForm}
                                        ordem={'3'} array={medicos}/>
                    )
                    }
                    {loadingP && (
                        <SelectComposto tipo={'o procedimento'} change={changeProcedimento} disable={props.disableForm}
                                        ordem={'4'} array={procedimentos}/>
                    )
                    }
                </>
            )}
            {part &&
                (
                    <>
                        < div className="ordem-cards">
                            {isOpen && (
                                <div className="card-back">
                                    <Tooltip label='Voltar'><Button onClick={handleBack}><ArrowBack></ArrowBack></Button></Tooltip>
                                    <Calendario change={onChangeCalendar}
                                                date={selectedDate}
                                                disable={disableWeekends}
                                                onMonthChange={(date) => onMonthChange(date)}
                                    />
                                </div>
                            )
                            }

                            {showForm && (
                                <>
                                    <div className={'final-form'}>
                                        {horarios.length !== 0 ?
                                            <HorariosListButtons horarios={horarios} changeHorarios={changeRadio}
                                                                 valor={valueHours}/> : null}
                                        {currentDoctor !== null ?
                                            <div className="doctor-message">{currentDoctor.mensagem}</div> : null}
                                        <Box width={400} alignItems={"center"}>
                                            <div className="top-card">Por favor, digite seu telefone</div>
                                            <Input id={'input'} isRequired color={'black'} value={tel}
                                                   onChange={inputNumberCell}
                                                   maxLength={11}
                                                   placeholder={'(DD)000000000'}></Input>
                                            <Text color={'black'} mb='1rem' fontSize={'smaller'}>
                                                A equipe do Sesc entrará em contato com você para confirmar o
                                                agendamento.
                                            </Text>
                                        </Box>
                                        <Box display={"flex"} gap={'1rem'}>
                                            <Button className={'arrow_button'} colorScheme={'red'} size={'lg'}
                                                    onClick={handleBack}>
                                                Cancelar
                                            </Button>
                                            <Button color={'white'} _hover={{bg: '#0d9fca'}} background={'#004587'}
                                                    size={'lg'}
                                                    onClick={handleConfirm}
                                                    disabled={!canSubmit}>Prosseguir</Button>
                                        </Box>

                                    </div>
                                </>
                            )}
                        </div>
                        {
                            !showModal ? null :
                                <ModalConfirm hable={showModal} close={() => setShowModal(false)}
                                              dataUser={formContol}/>
                        }
                    </>

                )
            }
        </div>)
}

export default function AgendamentoPage() {

    const location = useLocation(),
        [user, setUser] = useState([]),
        navigate = useNavigate(),
        [cor, setCor] = useState(),
        [disable, setDisable] = useState(false);

    useEffect(
        () => {
            if (location.state === null || location.state.credencial === null || location.state.credencial === undefined || !user) {
                setDisable(true)
                backClear()
            } else {
                setUser(location.state.credencial)
                validaDate(location.state.credencial.dataVencimento)
            }
        },
        []
    );

    const backClear = () => {
        setUser([])
        navigate('/')
    }

    const validaDate = (data) => {
        const date = ClienteF.converterDateToPadrao(data);
        const dateNow = new Date();
        let valida = date > dateNow;
        valida === true ? setCor('green') : setCor('red');
    }

    return (
        <>
            <div className="display">
                <CardUsuario dados={user} badgeColor={cor}/>
                <Heading ml={'1rem'} color={'white'} fontSize={'1.4rem'}>Clínica Integrada</Heading>
            </div>
            <Center>
                <VStack w='55%' hmin={'100%'}>
                    <HeadAgenda/>
                    <FormAgenda disableForm={disable} usuario={user}/>
                </VStack>
            </Center>
        </>
    )
}

function HeadAgenda() {
    return (
        <Image src={LogoClinica} loading="lazy" alt="Clinica Integrada Logo" maxH={'275px'}/>
    )
}
